import APIService from "./APIService";

export default {
    async getAll() {
        const res = await APIService.apiCall().get('gerencias/get-gerencias');
        return res.data;
    },
    
    async getById(id) {
        const res = await APIService.apiCall().get(`gerencias/get-by-id/${id}`);
        return res.data;
    },
    
    async create(data) {
        const res = await APIService.apiCall().post('gerencias/create', data);
        return res.data;
    },
    
    async update(id, data) {
        const res = await APIService.apiCall().put(`gerencias/update/${id}`, data);
        return res.data;
    },
    
    async delete(id) {
        const res = await APIService.apiCall().delete(`gerencias/delete/${id}`);
        return res.data;
    },

    // Métodos legados para compatibilidade
    async getAllGerencias() {
        return this.getAll();
    },
    
};